export const CARD_BG = 'https://static.fuxi.netease.com/yaotai/portal/20220627/l4wbgef5_card.png';
export const CARD_TEXT = [
  '传统的线下行业峰会筹备周期长：包含活动策划、嘉宾邀约、人员协调、会场布置等准备工作，对主办方来说，组织成本高、且耗时耗力。',
  '网易瑶台提供的一站式活动管理功能可以帮助主办方提高活动组织效率，并通过音视频畅聊、场景定制、智能捏脸等 AI 技术能力给与参会者一种更加创新的沉浸式参会体验。',
];

export const DEMANDS = [
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220721/l5uftgfu_911546.png',
    title: '活动策划',
    text: '从活动方案到内容设计，需要策划全流程内容，打造活动创新点。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220721/l5ugpaeg_396712.png',
    title: '高效组织',
    text: '完成嘉宾邀约、会务协调、会场布置、信息整理等各类繁杂的组织工作。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220721/l5ugpfsg_403696.png',
    title: '线上社交',
    text: '参会者需要多样的交互功能，满足简单的沟通交流和更进一步的社交需求。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4c5ypax_icon2.png',
    title: '场景定制',
    text: '根据不同活动需求，主办方需要定制个性化会场及其他办会功能，丰富活动体验。',
  },
];

export const FEATURES = [
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220907/l7r5842t_285732.png',
    title: '一站式的活动管理',
    desc: [
      '后台管理系统快捷创建活动信息，自由设置活动时间',
      '随时设置活动主页、开场白、公告议程等，助力完成行业峰会紧凑饱满的日程安排',
      '打通活动报名、场地部署、会议控场、数据分析播等活动管理全流程，满足主办方的多样化需求',
    ],
  },
  {
    rightText: false,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hdzpas_348116.png',
    title: '沉浸式的交流感官体验',
    desc: [
      'AI 智能捏脸，随心打造讲师及嘉宾专属虚拟形象、提供多种趣味性交互形式',
      '屏幕共享，PPT 嵌入式播放、实时翻译、视频畅聊、多个分会场自由切换等十项活动功能，应有尽有',
    ],
  },
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1n_920379.png',
    title: '个性化的场地和服装',
    desc: [
      '高精度复刻线下真实活动的多种会议厅、会客室、沙龙间、会展馆等，满足峰会的多种场地需求',
      '更多创意场景随心定制，古风、沙漠、火星发布厅等，用虚拟世界的情景来实现天马行空的创意',
      '支持定制峰会统一服装、座椅贴、引导牌等服饰装修',
    ],
  },
  {
    rightText: false,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1q_920381.png',
    title: '创意性的内容策划',
    desc: ['提供活动创意、内容设计等多链路的策划支持', '结合具体需求，定制专属活动创新玩法'],
  },
  // {
  //   rightText: true,
  //   image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1j_920375.png',
  //   title: '统计峰会多项数据',
  //   desc: [
  //     '参会名单统计和分析，报名、签到、互动等数据统计，实时监控峰会进程',
  //     '会后满意度数据、观看人数统计、等多维度统计，精准看到峰会价值',
  //   ],
  // },
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220901/l7igzaul_834413.png',
    title: '高质量的业务价值提升',
    desc: ['为展商、赞助商提供多方位品牌内容展示', '整合多渠道传播资源提升活动宣传效果'],
  },
];

export const ADVANTAGES = [
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd7_icon3.png',
    title: '一站式服务',
    text: '瑶台一站式全流程技术服务，满足会前准备、会中控场、会后传播等行业峰会各环节的多样性需求，助力主办方提升会议组织与运营效率。',
  },
  // {
  //   icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd6_icon2.png',
  //   title: '上市企业品牌背书',
  //   text: '网易是纳斯达克及香港上市企业，作为中国领先的互联网技术公司，在市场上具有较强的影响力，并获得了广泛用户群体的信任。瑶台是整合网易集团优势资源和能力，打造的服务活动市场的新平台。',
  // },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd5_icon1.png',
    title: '强有力的技术保障',
    text: '依托于网易在 3D 游戏引擎、AI、云计算等领域的多年积累，强大的技术实力保障平台安全稳定。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd8_icon4.png',
    title: '个性化定制',
    text: '主办方可以量身定制虚拟活动场地、虚拟角色形象、虚拟交互和会务组织功能，满足多样化活动需求。',
  },
];

export const SUCCESS_CASES = [
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '“华为云专属月·行业深耕”发布会',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6mzyq3n_802594.png',
    brief:
      // autocorrect: false
      '2021年10月15日，华为云携手网易伏羲举办了“华为云专属月·行业深耕”线上发布会。围绕“云上共创 互联网新价值”主题，此次发布会选取了在沉浸式虚拟活动平台（瑶台）中举办。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    // autocorrect: false
    title: '2021年，网易未来大会',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n046w5_057637.png',
    // autocorrect: false
    brief: '2021年12月，网易举办了 2021 网易未来大会。通过网易瑶台沉浸式活动平台，体验时空之门被打开的奥秘。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '网易云音乐 IPO 大会',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n046w1_057633.png',
    brief:
      // autocorrect: false
      '2021年12月2日，网易云音乐正式在港交所挂牌上市。线下仪式在杭州网易云音乐总部，线上仪式在网易伏羲沉浸式活动平台“瑶台”举办。在这个元宇宙中，“丁磊 2021”虚拟形象身着黑色西装、佩戴网易云音乐徽章，从观众席缓缓走向舞台。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '河南智慧旅游大会',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n046w3_057635.png',
    brief:
      // autocorrect: false
      '3月12日，2022 河南智慧旅游大会在郑州成功举办。本届大会结合网易瑶台线上元宇宙会议空间与“只有河南·戏剧幻城”线下会场，打造了国内首个规模最大、场景最丰富、持续时间最长的文旅元宇宙大会，为参会人员带来了一场身临其境的元宇宙场景体验。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '5.15 经侦宣传大会',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n046w4_057636.png',
    brief:
      '杭州市公安局高新区（滨江）分局组织开展“5·15”打击和防范经济犯罪宣传日活动暨滨江区企业刑事合规促进会基础建设工作委员会成立仪式。活动通过网易伏羲“元宇宙”在线沉浸式活动平台“瑶台”进行，虚拟会场气氛异常活跃。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: 'MCON 首届品牌元宇宙营销沉浸式峰会',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220823/l75udcki_264545.png',
    brief:
      // autocorrect: false
      '5月25日，MCON 首届品牌元宇宙营销沉浸式峰会在网易瑶台中举办，GDMS & MCON 创始人 Ken 与秒针营销科学院院长谭北平、网易传媒营销管理中心总经理宋琛瑶以及蓝色光标副董事长熊剑，共同揭幕并且发布了《元宇宙营销服务商生态图 1.0 版》',
  },
];
